var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4632 7.25464C22.2226 7.25464 22.8382 7.87025 22.8382 8.62964L22.8382 32.8101L27.8243 27.824C28.3613 27.2871 29.2319 27.2871 29.7688 27.824C30.3058 28.361 30.3058 29.2316 29.7688 29.7686L23.7319 35.8055C22.4789 37.0585 20.4475 37.0585 19.1946 35.8055L13.1576 29.7686C12.6206 29.2316 12.6206 28.361 13.1576 27.824C13.6946 27.2871 14.5652 27.2871 15.1022 27.824L20.0882 32.8101L20.0882 8.62964C20.0882 7.87025 20.7038 7.25464 21.4632 7.25464Z",
    fill: "url(#paint0_linear_1820_29419)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1820_29419",
    x1: 20.114,
    y1: 29.7729,
    x2: 30.9041,
    y2: 19.7414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A61FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#F237BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FA8EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC4A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionArrow);
export default __webpack_public_path__ + "static/media/section-arrow.acf830e781a313f529748c2f64a1b9bc.svg";
export { ForwardRef as ReactComponent };